import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login, isAuthenticated, error } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [localError, setLocalError] = useState("");

  // Render-time redirect (no effect, no setState-in-effect)
  if (isAuthenticated) return <Navigate to="/" replace />;

  const handleSubmit = async () => {
    if (loading) return;
    setLoading(true);
    setLocalError("");
    const result = await login(username.trim(), password);
    setLoading(false);
    if (result) {
      navigate("/");
    } else {
      setLocalError("Access denied. The vault remains shut.");
    }
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") handleSubmit();
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-[#333] p-8 sm:p-10 bg-[#0a0a0a] space-y-7">
        <div className="space-y-2">
          <div className="text-[0.6rem] tracking-[0.4em] uppercase text-[#A3A3A3]">
            Archivist Threshold
          </div>
          <h1 className="font-serif-display text-3xl tracking-tighter">
            Present the Key
          </h1>
          <p className="text-xs text-[#555] leading-relaxed">
            Identify yourself by A-file number (or visitor handle) and speak your alias.
            Archivists may alter the dossiers; visitors are witnesses only.
          </p>
        </div>

        <div className="space-y-4" onKeyDown={onKeyDown}>
          <label className="block">
            <div className="text-[0.6rem] tracking-[0.35em] uppercase text-[#555] mb-1">
              File / Handle
            </div>
            <input
              type="text"
              className="tiv-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="A-000 · Intern-417 · ..."
              autoComplete="username"
              required
              data-testid="admin-login-username"
            />
          </label>
          <label className="block">
            <div className="text-[0.6rem] tracking-[0.35em] uppercase text-[#555] mb-1">
              Alias
            </div>
            <input
              type="password"
              className="tiv-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              data-testid="admin-login-password"
            />
          </label>
          {(localError || error) && (
            <div className="text-xs text-[#721C1C] border border-[#721C1C] p-2 tracking-wide" data-testid="admin-login-error">
              {localError || error}
            </div>
          )}
          <button
            className="tiv-btn w-full"
            type="button"
            onClick={handleSubmit}
            disabled={loading}
            data-testid="admin-login-submit"
          >
            {loading ? "verifying..." : "Open the Vault"}
          </button>
        </div>

        <div className="text-[0.6rem] tracking-[0.35em] uppercase text-[#555] text-center pt-2 border-t border-[#333]">
          <Link to="/" className="hover:text-[#E3E1D9]">↩ Return to surface</Link>
        </div>
      </div>
    </div>
  );
}
